export default "__VITE_ASSET__CPIjb4yO__"